module.exports = __webpack_public_path__ + "assets/img/title_wish.926959fb.png";